// @flow
'use strict';

import * as React from 'react';

import type { ItemProps } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';
import Endereco from './endereco';

export default function Tomador({ item } : ItemProps) {
  return (
      <div className="tab-pane active">
        <h3>Tomador</h3>
        <RowDetalhes data={ item }>
          <ColumnDetalhes field="tomadorCpfCnpj" type="documento" width="25%">CPF / CNPJ</ColumnDetalhes>
          <ColumnDetalhes field="tomadorRazaoSocial" width="75%">Nome / Razão social</ColumnDetalhes>
        </RowDetalhes>

        <RowDetalhes data={ item }>
          <ColumnDetalhes field="tomadorIm" width="25%">Inscrição Municipal</ColumnDetalhes>
          <ColumnDetalhes field="tomadorEmail" width="75%">E-mail</ColumnDetalhes>
        </RowDetalhes>

        <Endereco item={ item.tomadorEndereco }/>
      </div>
  );
}